
export default {
  name: 'modal-importer-resultats',
  components: {},
  props: ['analyse'],
  data () {
    return {
      loading:false,
      files: [],
      fichiers: [],
      file_error: false,
      fichier_programmation: {
        programmation_vm: null,
      },
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    handleFilesUpload() {
      let uploadedFiles = this.$refs.vm_group_files.files;
      /**
      * Adds the uploaded file to the files array
      */
      this.files = [];

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
      //this.fichier_programmation.programmation_vm = this.files[0];

      this.file_error = false;
    },
    onSubmit(){
      this.$refs.upload_files_group_vm_form.validate().then((success) => {
        if(!success || this.files.length ==0){
          this.file_error= true
          return ;
        }
        this.loading = true
        let form_data = new FormData();

        //form_data.append("programmation_vm",this.fichier_programmation.programmation_vm)
        let fileIndex = -1
        this.files.forEach(
          element => {
            fileIndex++;
            console.log(fileIndex)
            form_data.append("programmation_vm_"+fileIndex,element)
          }
        )
        this.fichiers = form_data
        console.log(form_data)

        this.$store.dispatch("sendVisitesAnalysesFiles",{visite_id: this.$route.params.id,
                                                          analyse_id: this.analyse.id, 
                                                          data: form_data}).then(
            () => {
              this.files = [];
              this.$refs.upload_files_group_vm_form.reset()
              this.doSuccessMsg("Les résultats ont été importés avec succès")
              this.loading = false
              this.$refs.upload_anal_group_vm_close.click()
              this.fichiers = []

              setTimeout(function(){
                location.reload();
              },3000)
              
                                                    
        },error => {
          this.loading = false
          console.log(error)
        })

        
        // let inSocieteDetails = true
        // if(this.$route.name === 'VisiteMedicalePendingResultList'){
        //   inSocieteDetails = false
        // }
        // else{
        //   inSocieteDetails = true
        // }
        // this.$store.dispatch("uploadFileVisiteMedicale",{id:this.programmation.programmation_id,data:form_data},inSocieteDetails).then(
        //   () => {
        //     this.files = []
        //     this.$refs.upload_file_vm_form.reset()
        //     this.doSuccessMsg("Le résultat a été ajouté avec succès")
        //     this.loading = false
        //     this.$refs.upload_vm_close.click()

        //   },error=>{
        //       this.loading = false
        //       console.log(error)            
        //   }
        // )


      }

      )
    },
    doSuccessMsg: function(msg) {
      this.$toasted.show(msg, {
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          position: 'top-center',
          duration: 5000,
          theme: 'toasted-primary',
          type: 'success'
      })
  },
  }
}


